<template>
  <b-overlay :show="loading"
             spinner-variant="primary"
             spinner-type="grow">
    <div class="cont-steps container">

      <header-component class="align-self-start"></header-component>

      <template v-if="!loading">
        <template v-if="isMobile && !hideSteps">
          <steps-line-component v-if="current <= steps" class="py-1 align-self-end" :steps="steps"
                                :current="current"
                                @changeCurrent="changeCurrent(...arguments)"></steps-line-component>
        </template>
        <transition name="zoom-fade" mode="out-in">
          <router-view
              class="align-self-center"
              :options="options"
              :steps="steps"
              :current="current"
              :isMobile="isMobile"
              @setCurrent="current = $event"
              @setHideSteps="hideSteps = $event"
              @nextStep="nextStep(...arguments)"
              @getResults="getResults($event)"
              @setOptions="options = $event"
          />
        </transition>
        <template v-if="!isMobile && !hideSteps">
          <steps-line-component v-if="current <= steps" class="py-4 align-self-end" :steps="steps"
                                :current="current" @changeCurrent="changeCurrent(...arguments)"></steps-line-component>
        </template>
        <template v-else>
          <div class="my-4 pt-2 align-self-end text-center">
            <p class="h7-regular-black">&nbsp;</p>
          </div>
        </template>
      </template>
    </div>
  </b-overlay>
</template>

<script>
import StepsLineComponent from "@/components/StepsLineComponent";
import HeaderComponent from "@/components/HeaderComponent";

export default {
  name: 'CheckUpEnergetico',
  metaInfo: {
    title: 'Check-Up Energetico - Astea Energia Gas e Luce',
    meta: [
      {
        name: 'description',
        content: 'Scopri i vantaggi di passare a Astea Energia Luce e Gas. Personalizza con noi la tua energia!'
      }
    ]
  },
  data() {
    return {
      steps: 7,
      current: 1,
      loading: false,
      result: null,
      hideSteps: false,
      webPath: process.env.VUE_APP_WEB_PATH,

      options: {
        step: 1,
        casa: {
          mq: null,
          diProprieta: '',
          type: '',
          anno: '',
          persone: null,
          interventi: '',
        },
        consumi: {
          luce: null,
          gas: null,
        },
        caldaia: {
          anni: '',
          acqua_calda: '',
        },
        cucina_condizionatore: {
          cucina_gas: '',
          impianto_condizionamento: '',
        },
        energie_alternative: {
          impianto_solare_termico: '',
          impianto_solare_fotovoltaico: '',
          potenza_nominale: '',
        },
        user: {
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
          gia_cliente: '',
          codice_cliente: '',
        }
      },
      showResults: false,
      isMobile: false,
      windowSize:0,
    }
  },
  mounted() {
    this.handleWindowResize();
  },
  methods: {
    changeCurrent(step) {
      this.options.step = step;
      this.current = step;
      this.$router.push({name: 'step-' + step})
    },

    nextStep(nextStep, localOptions) {
      this.options = localOptions;
      this.options.step = nextStep;
      this.current = nextStep;
      this.$router.push({name: 'step-' + nextStep})
    },

    getResults(localOptions) {
      this.options = localOptions;
      this.options.step = this.steps + 1;
      this.current = this.steps + 1;
      this.$router.push({name: 'results', params: this.options})
    },

    handleWindowResize() {
      this.isMobile = window.innerWidth <= 991
    },
  },
  async created() {
    window.addEventListener('resize', this.handleWindowResize)

  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  components: {HeaderComponent, StepsLineComponent}
}
</script>

<style lang="scss">
.cont-steps {
  display: flex;
  flex-wrap: wrap;
  height: calc(var(--vh, 1vh) * 100);

  & > header,
  & > div {
    width: 100%;
  }
}

.form-group {
  label {
    font-size: 14px;
  }

  .form-control {
    padding: 12px 32px !important;
  }
}
</style>
